import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { map } from 'rxjs/internal/operators/map';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';
import { StoresConstant } from '../stores_api/constants/stores.constant';
import { AuthorConstant } from '../partner_content/constants/author.constant'

@Injectable({
  providedIn: 'root'
})
export class AuthorService {

  userId = sessionStorage.getItem('userId');
  loginUserRole = sessionStorage.getItem('userRole');
  INVITE_URL = StoresConstant.USERMGMT + StoresConstant.USERMANAGMENT +
    StoresConstant.SLASH_USERS + StoresConstant.SLASH + this.userId + StoresConstant.SLASH_USERS + StoresConstant.INVITE;
  PARTNER_URL = AuthorConstant.SLASH_PARTNER + AuthorConstant.SLASH_PARTNER + AuthorConstant.SLASH_PARTNERS;
  PARTNER_URL_SEARCH_PARTNERNAME = AuthorConstant.SLASH_PARTNER + AuthorConstant.SLASH_PARTNER + AuthorConstant.SLASH_PARTNERS
    + AuthorConstant.PARTNER_NAME_SEARCH_QUERY_PARAMETER;
  COMMON_URL = ActiveUserConstants.SLASH_USER_MANAGEMENT + ActiveUserConstants.USER_MANAGEMENT + ActiveUserConstants.SLASH_USER;

  constructor(private httpMethod: HttpMethodsService) { }

  getAllAuthor(pageNumber: number, filterString?: string) {
    let url = this.COMMON_URL + AuthorConstant.ROLE_AUTHOR_QUERY_PARAMETER + AuthorConstant.PAGE_NUMBER_QUERY_PARAM + pageNumber;

    if(filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
    .pipe(map((res: any) =>
        (res))
      );
  }

  inviteAuthorUser(userRole: object) {
    return this.httpMethod.post(this.INVITE_URL, userRole)
      .pipe(map((res: any) =>
        res));
  }

  getSearchByPartnerName(partnerName, sortBySortType, pageNumber) {
    const url = this.COMMON_URL + AuthorConstant.ROLE_AUTHOR_QUERY_PARAMETER + AuthorConstant.PAGE_NUMBER_QUERY_PARAM + pageNumber + sortBySortType + AuthorConstant.PARTNER_NAME_SEARCH_PARAMETER + partnerName;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res))
  }

  getPartnerData() {
    return this.httpMethod.get(this.PARTNER_URL)
      .pipe(map((res: any) =>
        res))
  }

  deleteAuthor(tempuid) {
    return this.httpMethod.deleteUser(this.COMMON_URL, tempuid);
  }

  getPartnerDataByOrder(sortby: string, sorttype: string) {
    const url = this.PARTNER_URL + AuthorConstant.PARTNER_DROPDOWN_SORT_BY + sortby + AuthorConstant.PARTNER_DROPDOWN_SORT_TYPE + sorttype;
    return this.httpMethod.get(url) 
      .pipe(map((res: any) =>
        res))
  }
}
